// JavaScript для mini-table
import { onReady } from '../base/init.js';

onReady(function () {
  // Код для mini-table
});
